import { useMemo } from 'react';
import { useInventoryContext, useUIContext } from '../../app/GameProviders';
import { computeDiscoveredSorted, filterBySearch } from './inventorySelectors';
import type { Material } from '../../types';

export function useInventorySearch() {
  const { inventory } = useInventoryContext();
  const { searchQuery } = useUIContext();

  const discovered: Material[] = useMemo(
    () => computeDiscoveredSorted(inventory),
    [inventory]
  );

  const filteredItems: Material[] = useMemo(
    () => filterBySearch(discovered, searchQuery),
    [discovered, searchQuery]
  );

  return { discovered, filteredItems };
}
